<div class="ant-slider-track" [ngStyle]="style"></div>
